// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { logOut } from 'helpers/auth'
import prepAndAssignUserData from './prepAndAssignUserData'

import {
  postRenewJWT,
  updateHeaderToken,
} from 'helpers/api'

// NOTE: in this function if !sessionTimeout === true
// this means that the UI is initializing. handle renewal accordingly.

const renewUserSession = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const sessionTimeout = getState().user.get('sessionTimeout')

      // this means we need to set Headers with JWT before request
      if (!sessionTimeout) {
        const jwt = localStorage.getItem('L_JWT')
        updateHeaderToken(jwt)
      }

      try {
        const { entity } = await postRenewJWT()
        await dispatch(prepAndAssignUserData(entity))
        clearTimeout(sessionTimeout)
      } catch (err) {
        // UI was not initialized and login attempt failed.
        // clear stored jwt data and force the page to /login.
        if (!sessionTimeout) {
          await logOut()
        }

        console.warn('Error in renewUserSession: ', err)
        throw err
      }
    })
  )
)

export default renewUserSession
